import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { openSubSpecialisationDropdown } from "../../../redux/actions/user_action";
import {
  ArrowLeftIconStyled,
  MajorCategoryItemText,
  MajorSpecialisationTitle,
  SubSpecialisationBox,
  SubSpecialisationContent,
  SubSpecialisationItem,
  SubSpecialisationScrollBar,
} from "./styles";

export function SubSpecialisation(props) {
  const classes = SubSpecialisationScrollBar();
  const { specialisationHandler, setAnchorEl } = props;
  const dispatch: any = useDispatch();
  const dropdownState = useSelector(
    (state: any) =>
      state?.user?.openSpecialisationDropdown?.openSpecialisationDropdown
  );
  const subSpecialisationDropdown = useSelector(
    (state: any) =>
      state?.user?.openSubSpecialisationDropdown?.openSubSpecialisationDropdown
  );
  const subSpecialisation = useSelector(
    (state: any) => state?.user?.subSpecialisation?.subSpecialisation
  );
  const { t } = useTranslation();

  const getSpecialisationLabel = (specialisationValue?: string) => {
    if (!specialisationValue) return "";
    const key = specialisationValue
      .toString()
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "");
    return t(`companydetail.specialisation_labels.${key}`, {
      defaultValue: specialisationValue,
    });
  };

  function handleClickBack() {
    if (dropdownState) {
      dispatch(openSubSpecialisationDropdown(false));
    }
  }

  function handleClickSubCategory(specialisation) {
    specialisationHandler(specialisation);
    dispatch(openSubSpecialisationDropdown(false));
    setAnchorEl(null);
  }

  return (
    <Fragment>
      <SubSpecialisationBox
        $open={subSpecialisationDropdown?.toString()}
        className={classes.scrollBar}
      >
        <SubSpecialisationContent onClick={handleClickBack}>
          <ArrowLeftIconStyled />
          <MajorSpecialisationTitle>
            {getSpecialisationLabel(subSpecialisation?.name)}
          </MajorSpecialisationTitle>
        </SubSpecialisationContent>
        {subSpecialisation?.subSpecialisations?.map((subSpecialisation) => (
          <SubSpecialisationItem
            key={subSpecialisation?.id}
            // @ts-ignore
            onClick={() => handleClickSubCategory(subSpecialisation?.name)}
          >
            <MajorCategoryItemText>
              {getSpecialisationLabel(subSpecialisation?.name)}
            </MajorCategoryItemText>
          </SubSpecialisationItem>
        ))}
      </SubSpecialisationBox>
    </Fragment>
  );
}
